<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  mounted() {
    this.renderChart(
      {
        labels: [
          "01 may 2021",
          "05 may 2021",
          "10 may 2021",
          "15 may 2021",
          "20 may 2021",
          "25 may 2021",
          "30 may 2021",
        
        ],
        datasets: [
          {
            label: "CPU Usage",
            backgroundColor: "#41b883",
            data: [90, 99, 99, 20, 10]
          },
          {
            label: "Mem Usage",
            backgroundColor: "#FFAA0C",
            data: [400, 400, 200, 100, 200]
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
</script>
